module.exports = __webpack_public_path__ + "img/compartir.e5cefa99.svg";